/**
 * Theme entity class
 */

/**
 * ThemeFactory
 * returns Theme entity class
 *
 * @class ThemeFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.Theme} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ThemeFactory
 */
/* @ngInject */
export default function ThemeFactory (Entity) {
  /* === Theme class === */

  /**
   * Theme model
   *
   * @class Theme
   * @classdesc Theme model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @param {Object} [object] - initial object, containing Theme entity fields
   * @return {models.Theme} Theme entity
   */
  function Theme () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  Theme.prototype = Object.create(Entity.prototype)
  Theme.prototype.constructor = Theme

  /* === Theme instance methods & fields === */

  Object.assign(Theme.prototype, {

    /**
     * instance fields
     *
     * @memberof models.Theme#
     * @type {Object}
     */
    _fields: {
      id: Number,
      name: String,
      subThemes: ['SubTheme']
    }

  })

  /* === Theme static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(Theme, Entity)
  Theme._name = 'Theme'
  Theme.init()

  return Theme
}
